module.exports = __webpack_public_path__ + "static/media/haute1B.4f082a64.jpg";